import { DeviceOperationalState } from '@/__generated__/graphql';
import { useConfetti } from '@/hooks/useConfetti';
import { useGlobalModal } from '@/hooks/useGlobalModal';
import { useCallback } from 'react';

export const useUpdateOperationalStateCompleteCallback = (deviceId: string) => {
  const { setModalState: setCreateObservationModalState } = useGlobalModal(
    'createDeviceObservationModal',
  );
  const { setModalState: setAfterUpdateTasksModal } = useGlobalModal('afterUpdateTasksModal');
  const { partyHard } = useConfetti();

  return useCallback(
    (previousState: DeviceOperationalState, newState: DeviceOperationalState) => {
      if (
        previousState === DeviceOperationalState.Initialization &&
        newState === DeviceOperationalState.Active
      ) {
        partyHard();
      }

      if (
        previousState === DeviceOperationalState.Maintenance &&
        newState === DeviceOperationalState.Active
      ) {
        setAfterUpdateTasksModal({
          open: true,
          deviceId,
        });
      }

      if (newState === DeviceOperationalState.OutOfService) {
        setCreateObservationModalState({
          open: true,
          deviceId,
          initialContent: 'DISPOSITIVO ARCHIVADO:\n',
        });
      }
    },
    [partyHard, deviceId, setCreateObservationModalState, setAfterUpdateTasksModal],
  );
};
